<template>
  <div>
    <curation-filter-link :filterLayout="filterLayout":filterData="filterSet.filter"
                          :sortData="filterSet.sort" :paginationData="filterSet.page"></curation-filter-link>
    <curation-list-link :listLayout="listLayout" :paginationData="filterSet.page" :curationData="List"></curation-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :type="curationType"></pagination-link>
  </div>
</template>

<script>
import CurationFilterLink from "@/components/curation/CurationFilterLink";
import CurationListLink from "@/components/curation/CurationListLink";
import PaginationLink from "@/components/curation/PaginationLink";
import curationUtil from "@/components/curation/curationUtil";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";

const {filterConfig} = curationUtil;

export default {
  name: "CurationListComponent",
  mixins: [curationUtil, filterMixins, listMixins],
  components: {
    CurationFilterLink,
    CurationListLink,
    PaginationLink
  },
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      setSort: this.setSort,
      setCurationListData: this.setData,
    }
  },
  props: {
    curationType: {default: ''},
    memberKey: {default: 0},
  },
  data() {
    return{
      getFunc: '',
      listLayout: '',
      filterLayout: '',
      paginationLayout: '',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig);
    this.setParserType('url', this.$route.fullPath);
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initConfig(){
      let config = this.returnCurationConfig(this.curationType)
      this.listLayout = config.listLayout;
      this.filterLayout = config.filterLayout;
      this.paginationLayout = config.paginationLayout;
      this.getFunc = config.getFunc;
      this.listApiParamSet = config.listApiParamSet;
      this.pageRow = config.pageRow;
      this.keyName = config.keyName;

      if (config.pageRow && config.pageRow != this.filterSet.page.size) {
        this.pageRow = config.pageRow;
        this.filterSet.page.size = config.pageRow;
        this.pageClass.setterPage('size', this.pageRow);
      }

      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      if (!util.isEmpty(this.memberKey)) {
        // params.no = this.memberKey
        params[this.keyName] = this.memberKey
      }
      let listOptions = {
        url: this.$api.$curation[this.getFunc],
        defaultParams: params,
      }
      this.initList('api', listOptions);
    },
    setData(key, value) {
      this[key] = value
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>